import * as Icons from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { ASSETS, MANPOWER, STRENGTHS } from "../data/content";

export const WhyTrustUs = () => (
  <section data-testid="why-trust-section" className="bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
      <div className="grid gap-16 lg:grid-cols-12 lg:gap-20">
        <Reveal className="lg:col-span-5">
          <SectionLabel>Why Trust Us</SectionLabel>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight tracking-tight text-[#0A192F]">
            Expert in recruiting the right person for the right job.
          </h2>
          <p className="mt-7 text-base leading-relaxed text-slate-600">
            We have network in worldwide about engineering expert executives who is
            having good quality of experience in engineering fields.
          </p>
          <div className="relative mt-10 overflow-hidden">
            <img
              src={ASSETS.welding}
              alt="Welding inspection in a workshop"
              className="h-72 w-full object-cover"
            />
            <div className="absolute inset-0 bg-[#0A192F]/30" />
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <div className="grid gap-6 sm:grid-cols-3">
            {STRENGTHS.map((s, i) => {
              const Icon = Icons[s.icon] || Icons.CircleDot;
              return (
                <Reveal key={s.title} delay={i * 0.08}>
                  <div
                    data-testid={`strength-card-${i}`}
                    className="h-full border border-slate-200 p-7 hover:-translate-y-1 hover:border-[#D4AF37] hover:shadow-lg hover:shadow-slate-200/70 transition-[transform,border-color,box-shadow] duration-300"
                  >
                    <Icon size={22} className="text-[#D4AF37]" />
                    <h3 className="mt-5 font-display text-sm font-extrabold uppercase tracking-[0.18em] text-[#0A192F]">
                      {s.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.body}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <Reveal delay={0.12}>
            <p className="mt-14 font-display text-xs font-bold uppercase tracking-[0.24em] text-slate-500">
              Manpower &amp; Management Solutions
            </p>
            <div className="mt-6 divide-y divide-slate-200 border-y border-slate-200">
              {MANPOWER.map((m, i) => (
                <div
                  key={m.title}
                  data-testid={`manpower-item-${i}`}
                  className="group grid gap-3 py-6 sm:grid-cols-12 sm:gap-8"
                >
                  <h4 className="sm:col-span-4 font-display text-sm font-bold text-[#0A192F] group-hover:text-[#B08D2A] transition-colors duration-300">
                    {m.title}
                  </h4>
                  <p className="sm:col-span-8 text-sm leading-relaxed text-slate-600">
                    {m.body}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
